import { createRouter, createWebHistory } from 'vue-router';
import { registerUserToken, setupMessageListener } from '@/firebaseService';
import store from '@/store';

let fcmInitialized = false; // ← flag permanente, no se resetea

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "view-login" */ '@/views/LoginView.vue'),
    meta: {
      authRequired: false,
    },
  },
  {
    path: '/reportes',
    name: 'reportes',
    component: () => import(/* webpackChunkName: "view-reports" */ '@/views/ReportsView.vue'),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/calendar',
    name: 'calendar',
    component: () => import(/* webpackChunkName: "view-calendar" */ '@/views/CalendarView.vue'),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/chat',
    name: 'chat',
    component: () => import(/* webpackChunkName: "view-chat" */ '@/views/ChatView.vue'),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/leads',
    name: 'leads',
    component: () => import(/* webpackChunkName: "view-leads" */ '@/views/LeadsView.vue'),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/dates',
    name: 'dates',
    component: () => import(/* webpackChunkName: "view-dates" */ '@/views/DatesView.vue'),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/contacts',
    name: 'contacts',
    component: () => import(/* webpackChunkName: "view-contacts" */ '@/views/ContactsView.vue'),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "view-login" */ '@/views/LoginView.vue'),
    meta: {
      authRequired: false,
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
router.afterEach(async (to) => {
  // Ocultar loading
  const appLoading = document.getElementById('loading-bg');
  if (appLoading) appLoading.style.display = 'none';

  // 🔐 Solo si hay sesión
  const userInfo = localStorage.getItem('userInfo');
  if (!userInfo) return;

  // 🔥 Solo inicializar Firebase UNA sola vez
  if (fcmInitialized) return;
  fcmInitialized = true; // ← marcar ANTES del await para evitar race conditions

  try {
    console.log('[FCM] Inicializando...');

    // 1️⃣ Primero registrar el token (SW + permisos)
    await registerUserToken(store);

    // 2️⃣ Luego activar el listener de foreground
    setupMessageListener();

    console.log('[FCM] ✅ Inicialización completa');
  } catch (e) {
    fcmInitialized = false; // ← permitir reintento si falló
    console.error('[FCM] ❌ Error inicializando:', e);
  }
});

router.beforeEach((to, from, next) => {
  const userInfo = localStorage.getItem('userInfo');
  // const token = localStorage.getItem('accessToken');
  if (to.meta.authRequired) {
    if (!userInfo) {
      router.push({ path: '/login', query: { to: to.path } });
    } else {
      // store.commit('SET_BEARER', localStorage.getItem('accessToken'));
      // const userInfo = JSON.parse(localStorage.getItem('userInfo'));
    }
  } else {
    // eslint-disable-next-line no-lonely-if
    if (userInfo) {
      if (to.name === 'home' || to.name === 'login') {
        router.push({ path: '/leads' });
      }
    }
  }
  return next();
});

export default router;
